import clsx from 'clsx';
import {FC, ReactNode} from 'react';

export type ModalHeaderProps = {
    children: ReactNode;
    className?: string;
};

const ModalHeader: FC<ModalHeaderProps> = ({children, className}) => (
    <div
        className={clsx(
            'border-b border-b-grey-300 p-4 pb-2 drop-shadow-none',
            className,
        )}
    >
        <span className="text-base font-semibold">{children}</span>
    </div>
);

export default ModalHeader;
